<template>
  <div class="container-fluid hv-100">
    <div class="row justify-content-center h-100">
        <!-- Form -->
        <div class="col-12 col-lg-7 bg-white mx-0 px-0 d-flex flex-row  align-items-center">
            <div class="col-md-6 offset-md-3">
              <div class="wrapper-form"
                v-if="emailSent() && showVerificationCode"
              >
                <div class="my-2 py-0">
                  <h3 class="text-lg-left my-1"><span class="font-weight-bold">
                    {{ $t("lang.label.verificationcode") }}</span>
                  </h3>
                  <p id="codeHelp" class="form-text small">
                    {{ $t("lang.label.insertthecodethatyoureceivedbyemail") }}
                  </p>
                </div>
                <div class="mt-4 ml-1">
                  <div class="form-row my-3">
                    <label for="">{{ $t('lang.label.insertcode') }}</label>
                    <input
                      id="code"
                      type="text"
                      class="form-control"
                      v-model="code"
                      required="true"
                    />
                    <div class="col-12" v-if="codeSent">
                      <span class="mt-2 mr-2 mb-4">
                        {{ $t('lang.label.login-code-sent') }}
                      </span>
                      <img
                        src="@/assets/images/icons_login/zorro-icon.png"
                        class="icon-zorro"
                      />
                    </div>
                    <div
                      class="col-12"
                      v-if="alert.message && !submittedCodeSecond"
                      :class="`mt-1 alert ${alert.type}`"
                    >
                      {{ alert.message }}
                    </div>
                    <div class="col-12" v-if="submittedCodeSecond && alert.message">
                      <div class="mt-1">
                        <AlertError :msgError="alert.message" />
                      </div>
                    </div>
                    <div class="col-md-12 mt-3 px-0">
                      <div class="row mx-0">
                        <div class="col-sm-12 col-md-6 pl-0 pr-1 mx-0">
                          <button
                          class="btn btn-ligth btn-block border border-primary text-primary  mt-2"
                          @click="resendVerificationCode()"
                          >
                            {{$t('lang.label.resendcode')}}
                          </button>
                        </div>
                        <div class="col-sm-12 col-md-6 pl-1 pr-0 mx-0">
                          <button
                          class="btn btn-primary btn-block mt-2"
                          @click="checkVerificationCode"
                          >
                            {{ $t("lang.button.submitcode") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center mr-3">
                    <router-link class="ml-3" to="/login">
                    {{ $t("lang.button.logout") }}
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="wrapper-form" v-if="!emailSent()">
                <div v-if="hash != null">
                  <h4>{{ $t("lang.label.createteamaccount") }}</h4>
                </div>
                <div class="mb-5" v-else>
                  <div class="d-none d-block d-lg-none text-center mt-3">
                    <img :src="require('@/assets/images/logo-h.png')" width="290px" alt="logo">
                    <h4 class="my-0 text-center font-weight-bold">{{ $t('lang.label.login-create')}}</h4>
                    <span class="mt-3">{{ $t('lang.label.login-b2b')}}</span>
                  </div>
                  <div class="d-none d-lg-block">
                    <h4 class="my-0 font-weight-bold">{{ $t('lang.label.login-create')}}</h4>
                    <span>{{ $t('lang.label.login-b2b')}}</span>
                  </div>
                </div>
                <form class="pt-0 mt-0" v-on:submit.prevent="handleSubmit">
                  <!-- Field Email -->
                  <div class="form-row my-0">
                    <label for="" class="ml-1 my-1">{{$t('lang.label.email')}}</label>
                    <div class="form-group col-md-12 my-0">
                      <input
                        id="email"
                        type="email"

                        pattern="^(?!.*@(?:gmail.com|yahoo.com|hotmail.com|aol.com|hotmail.co.uk|hotmail.fr|msn.com|yahoo.fr|wanadoo.fr|orange.fr|comcast.net|yahoo.co.uk|yahoo.com.br|yahoo.co.in|live.com|rediffmail.com|free.fr|gmx.de|web.de|yandex.ru|ymail.com|libero.it|outlook.com|uol.com.br|bol.com.br|mail.ru|cox.net|hotmail.it|sbcglobal.net|sfr.fr|live.fr|verizon.net|live.co.uk|googlemail.com|yahoo.es|ig.com.br|live.nl|bigpond.com|terra.com.br|yahoo.it|neuf.fr|yahoo.de|alice.it|rocketmail.com|att.net|laposte.net|facebook.com|bellsouth.net|yahoo.in|hotmail.es|charter.net|yahoo.ca|yahoo.com.au|rambler.ru|hotmail.de|tiscali.it|shaw.ca|yahoo.co.jp|sky.com|earthlink.net|optonline.net|freenet.de|t-online.de|aliceadsl.fr|virgilio.it|home.nl|qq.com|telenet.be|me.com|yahoo.com.ar|tiscali.co.uk|yahoo.com.mx|voila.fr|gmx.net|mail.com|planet.nl|tin.it|live.it|ntlworld.com|arcor.de|yahoo.co.id|frontiernet.net|hetnet.nl|live.com.au|yahoo.com.sg|zonnet.nl|club-internet.fr|juno.com|optusnet.com.au|blueyonder.co.uk|bluewin.ch|skynet.be|sympatico.ca|windstream.net|mac.com|centurytel.net|chello.nl|live.ca|aim.com|bigpond.net.au)+$).*$"
                        :title="$t('lang.accountcreation.email')"

                        class="form-control"
                        v-model="username"
                        required="true"
                      />
                      <small id="emailHelp" class="form-text dark-gray">{{
                        $t(
                          "lang.label.youwillhavetoconfirmthatthisemailisyours"
                        )
                      }}</small>
                    </div>
                  </div>
                  <!-- Field Firstname and lastname -->
                  <div class="form-row my-2">
                    <div class="col-sm-12 col-md-6 my-1">
                      <label for="" class="ml-1 mb-2">{{$t('lang.label.firstname')}}</label>
                      <input
                        id="firstname"
                        type="text"
                        class="form-control"
                        v-model="firstname"
                        required="true"
                      />
                    </div>
                    <div class="col-sm-12 col-md-6 my-1">
                      <label for="" class="ml-1 mb-2">{{$t('lang.label.lastname')}}</label>
                      <input
                        id="lastname"
                        type="text"
                        class="form-control"
                        v-model="lastname"
                        required="true"
                      />
                    </div>
                  </div>
                  <!-- Field Language -->
                  <div class="form-row my-2 px-0">
                    <div class="col-md-12">
                      <label for="" class="ml-1 my-1">{{$t('lang.label.language')}}</label>
                      <div class="input-group my-1 mx-0 px-0">
                        <span class="input-group-text px-1 mr-2">
                          <img
                            :src="flag"
                            class="flag"
                            />
                        </span>
                        <select
                          v-model="language_id"
                          class="form-control text-secondary py-0 my-0"
                          required="true"
                        >
                          <option
                            v-for="(lang, i) in langs"
                            :key="`Lang${i}`"
                            :value="lang.id"
                          >
                            {{ lang.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- Field phone -->
                  <div class="form-row my-2 px-0">
                    <div class="col-12">
                      <label for="" class="ml-1 my-1">{{$t('lang.label.mobile_phone')}}</label>
                      <div class="input-group my-0 mx-0 px-0">
                        <button type="button"
                          @click="showFlag = true"
                          class="btn btn-light  px-0 py-0 my-0 mx-0"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span  class="input-group-text px-1">
                          <img
                          :src="flagActually"
                          class="flag ml-0 mr-2"
                          />
                          + {{ country_id.phone_code }}
                        </span>
                        </button>
                        <div class="dropdown-menu dropdown-menu-left">
                          <button v-for="(country, i) of countriesFiltered.filter( e => e.visible)"
                                class="dropdown-item"
                                type="button"
                                @click="changeCountry(country.id)"

                                :key="i">
                            <img
                              :src="flag2(country.id)"
                              class="flag2"
                            />
                            <span class="ml-2 small">+ {{ country.phone_code }} {{ country.name }}</span>
                          </button>
                          <div class="col-12 px-4 py-2">
                            <span>Other country</span>
                            <input class="my-1 border"
                              placeholder="Your country..."
                              type="text"
                              v-model="filterCountry">
                          </div>

                        </div>
                        <input
                          id="phone"
                          type="number"
                          class="form-control ml-2"
                          v-model="phone"
                          required="true"
                        >
                      </div>
                    </div>
                  </div>
                  <!-- Field Company -->
                  <div class="form-row my-2">
                    <div class="col-sm-12 col-md-12">
                    <label for="" class="ml-1 my-1">{{$t('lang.label.company')}}</label>
                    <div class="input-group my-1">
                      <input
                        id="company"
                        type="text"
                        class="form-control"
                        v-model="company"
                        required="true"
                      />
                    </div>
                  </div>
                  </div>
                  <!-- Field Password -->
                  <div class="form-row my-2">
                    <div class="form-group col-md-6 my-1">
                      <label for="" class="ml-1 mb-2">{{$t('lang.label.password')}}</label>
                      <input
                        type="password"
                        class="form-control"
                        id="password"
                        v-model="password"
                        required
                        :title="$t('lang.validation.password')"
                        required="true"
                      />
                      <!-- <small class="form-text dark-gray">{{
                        $t("lang.validation.password")
                      }}</small> -->
                    </div>
                    <div class="form-group col-md-6 my-1">
                      <label for="" class="ml-1 mb-2">{{$t('lang.label.confirmpassword')}}</label>
                      <input
                        type="password"
                        pattern=".{8,}"
                        required
                        title="8 characters minimum"
                        v-model="confirmpass"
                        class="form-control"
                        id="confirmpass"
                        required="true"
                      />
                    </div>

                    <div class="form-group col-12" v-if="referred">
                      {{ $t('lang.label.codepromo') }}
                      <input
                        type="text"
                        v-model="referred"
                        class="form-control"
                        disabled
                      />
                    </div>
                    <div
                      v-if="alert.message && !submittedDataSecond"
                      :class="`alert ${alert.type}`"
                    >
                      {{ alert.message }}
                    </div>
                    <div v-if="submittedDataSecond && alert.message">
                      <div class="mt-4">
                        <AlertError :msgError="alert.message" />
                      </div>
                    </div>
                    <div v-if="errors.length" :class="`alert ${alert.type}`">
                      <li v-for="error in errors">{{ error }}</li>
                    </div>
                  </div>

                  <div class="mt-2" v-if="password">
                        <small >
                          <p class="mb-1">{{$t('lang.label.login-pass-contain')}}</p>
                          <span class="ml-1" :class="{'text-secundary': !validatePassword.long,'text-success': validatePassword.long}">
                            <i v-if="validatePassword.long" class="icon-checkmark ml-1"></i>
                            <span v-else class="ml-3"></span>
                            <span class="ml-1">{{$t('lang.label.login-pass-beetween')}}</span>
                          </span>
                          <span class="ml-1" :class="{'text-secundary': !validatePassword.uppercase,'text-success': validatePassword.uppercase}">
                            <i v-if="validatePassword.uppercase" class="icon-checkmark ml-1"></i>
                            <span v-else class="ml-3"></span>
                            <span class="ml-1">{{$t('lang.label.login-pass-uppercase')}}</span>
                          </span>
                          <span class="ml-1" :class="{'text-secundary': !validatePassword.lowercase,'text-success': validatePassword.lowercase}">
                            <i v-if="validatePassword.lowercase" class="icon-checkmark ml-1"></i>
                            <span v-else class="ml-3"></span>
                          <span class="ml-1">{{$t('lang.label.login-pass-lowercase')}}</span>
                          </span>
                          <span class="ml-1" :class="{'text-secundary': !validatePassword.number,'text-success': validatePassword.number }">
                            <i v-if="validatePassword.number" class="icon-checkmark ml-1"></i>
                            <span v-else class="ml-3"></span>
                            <span class="ml-1">{{$t('lang.label.login-pass-number')}}</span>
                          </span>
                        </small>
                      </div>
                  <div class="mt-3">
                     <div class="form-check">
                      <input
                        class="form-check-input "
                        :class="{'is-invalid': checkPolicy === false}"
                        type="checkbox"
                        value=""
                        id="invalidCheck3"
                        aria-describedby="invalidCheck3Feedback"
                        v-model="checkPolicy"
                        >
                      <label class="form-check-label" for="invalidCheck3">
                        I agreee to the Oliverlist
                            <a
                              class="text-primary"
                              href="https://oliverlist.com/terms-of-services/"
                              target="_blank"
                              >{{ $t("lang.label.termsofuse") }} </a
                            >
                      </label>
                      </div>
                      <div class="form-check mt-2">
                      <input
                        class="form-check-input"
                        :class="{'is-invalid': checkAgree === false}"
                        type="checkbox"
                        value=""
                        id="invalidCheck3"
                        v-model="checkAgree"
                        >
                      <label class="form-check-label" for="invalidCheck3">
                      I understand that my account information will be used according to Oliverlist
                          <a
                            class="text-primary"
                            href="https://oliverlist.com/privacy-policy/"
                            target="_blank"
                            >{{ $t("lang.label.privacypolicy") }}.</a
                          >
                      </label>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mt-3">
                    <button
                      id="NewAccount"
                      class="btn btn-primary btn-block themed-button"
                    >
                      {{ $t("lang.button.register") }}
                    </button>
                  </div>
                </form>
              </div>
              <div class="wrapper-form" v-if="showUserParameters">
                <div class="my-4">
                  <h2 class="dark-blue">
                    {{ $t("lang.label.aboutyourcompany") }}
                  </h2>
                </div>
                <form class="mt-4" v-on:submit.prevent="handleSubmitParameters">
                  <div class="form-row my-3">
                    <div class="col-md-12" v-if="showClientParameters">
                      {{ $t("lang.label.howknowus") }}
                      <treeselect
                        v-model="how_they_know_us"
                        class="mb-2"
                        :multiple="false"
                        :required="false"
                        :maxHeight="200"
                        :show-count="true"
                        :searchable="false"
                        :append-to-body="true"
                        :options="howKnowOptions"
                      >
                      </treeselect>
                    </div>

                    <div class="col-md-12" v-if="showClientParameters">
                      {{ this.$t("lang.lookingfor.label") }}
                      <treeselect
                        v-model="looking_for"
                        class="mb-2"
                        :multiple="false"
                        :required="false"
                        :maxHeight="200"
                        :show-count="true"
                        :searchable="false"
                        :append-to-body="true"
                        :options="lookingFor"
                      >
                      </treeselect>
                    </div>
                    <div class="col-md-12" v-if="showClientParameters">
                      {{ $t("lang.label.companytype") }}
                      <treeselect
                        v-model="param_5"
                        class="mb-2"
                        :multiple="false"
                        :required="false"
                        :maxHeight="200"
                        :show-count="true"
                        :searchable="false"
                        :append-to-body="true"
                        :options="companySizeOptions"
                        @select="onSelect"
                        @deselect="onDeselect"
                      >
                      </treeselect>
                    </div>
                    <div class="col-md-12" v-if="showClientParameters">
                      {{ this.$t("lang.label.industry") }}
                      <!-- CATEGORIES GOOGLE -->
                      <treeselect
                        v-model="categories_allowed"
                        class="mb-2"
                        :multiple="false"
                        :required="false"
                        :maxHeight="200"
                        :show-count="true"
                        :append-to-body="true"
                        :searchable="true"
                        :options="hierarchyoptionsGoogle"
                      >
                        <label
                          slot="option-label"
                          slot-scope="{
                            node,
                            shouldShowCount,
                            count,
                            labelClassName,
                            countClassName,
                          }"
                          :class="labelClassName"
                        >
                          {{ node.label }}
                          <!-- <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span> -->
                        </label>
                      </treeselect>
                    </div>
                    <div class="col-md-12">
                      {{ this.$t("lang.label.yourposition") }}
                      <treeselect
                        v-model="categories_search_level"
                        class="mb-2"
                        :multiple="false"
                        :required="false"
                        :maxHeight="200"
                        :show-count="true"
                        :searchable="false"
                        :append-to-body="true"
                        :options="categories_search_level_options"
                      >
                      </treeselect>
                    </div>
                    <div class="col-md-12" v-if="false">
                      {{ this.$t("lang.label.yourarea") }}
                      <treeselect
                        v-model="categories_search_function"
                        class="mb-2"
                        :multiple="false"
                        :required="false"
                        :maxHeight="200"
                        :show-count="true"
                        :searchable="false"
                        :append-to-body="true"
                        :options="categories_search_function_options"
                      >
                      </treeselect>
                    </div>
                  </div>
                  <button class="btn btn-primary themed-button text-right">
                    {{ $t("lang.label.startusingoliver") }}
                  </button>
                </form>
              </div>
              <div class="col-12" v-if="showVerificationCode && !emailSent()">
                <div class="row d-flex flex-row justify-content-center">
                  <div class="col-12 mt-3 text-center">
                    <span class="mb-4">
                      <router-link to="/login" class="nav-link pxmd-0 px-2 ">
                        {{ $t("lang.label.if-you-have-account") }} <span class="text-primary">{{ $t("lang.button.connect") }}</span>
                      </router-link>
                    </span>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <!-- Features -->
        <!-- <div class="container fluid d-none d-md-block"> -->
          <Features />
        <!-- </div> -->
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import AlertError from "@/components/AlertError.vue";
import Features from "@/components/AccountCreation/Steps/Features.vue";
import {
  clientsService,
  campaignsService,
  categoriesService,
  usersService,
  lenguagesService,
  countriesService
} from "@/_services";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Logo from '@/assets/images/logo-h.png'
import $ from "jquery";


export default {
  computed: {
    ...mapState({
      emailConfirmed: (state) => state.authentication.status.emailVerified,
    }),
    flag(){
      const flag = this.flags.find( el => el.id === this.language_id).text
      return require('@/assets/images/flags/'+ flag )
    },
    flag2(){
      return (countryId) => {
        const flag = this.countries.find( el => el.id === countryId).iso
        return require('@/assets/images/flags/' + flag +  '.svg' )
      }
    },
    alert() {
      return this.$store.state.alert;
    },
    userEmail(){
      const userEmail = this.usersame == '' || this.usersame == undefined ? this.$store.state.authentication.user.username : this.usersame
      return userEmail
    }
  },
  props: {
    user: Object,
  },
  data() {
    return {
      checkAgree: null,
      checkPolicy: null,
      countriesFiltered: [],
      filterCountry: null,
      flagActually: null,
      showFlag: true,
      optionsDefault: ['CA', 'ES', 'IT', 'GB', 'US', 'FR', 'DE'],
      countries: [],
      codeSent: false,
      validatePassword:{
        lowercase: false,
        uppercase: false,
        number: false,
        long: false,
      },
      flags:[
        { id:"1", text: "fr.svg"},
        { id:"2", text: "us.svg"},
        { id:"3", text: "es.svg"},
      ],
      submittedCode: false,
      submittedCodeSecond: false,
      submittedData: false,
      submittedDataSecond: false,
      codepromo:"",
      referred:"",
      errors: [],
      lastname: "",
      firstname: "",
      company: "",
      phone: "",
      password: "",
      email: "",
      username: "",
      language_id: "1",
      country_id: {
          "id": "73",
          "name": "France",
          "iso": "fr",
          "phone_code": "33",
          "visible": true
      },
      confirmpass: "",
      code: null,
      clientId: null,
      hash: null,
      showVerificationCode: true,
      showClientParameters: false,
      showUserParameters: false,
      param_5: null,
      salaries: null,
      companySizeOptions: [],
      categories_allowed: null,
      hierarchyoptionsGoogle: [],
      categories_search_function: null,
      categories_search_function_options: [],
      categories_search_level: null,
      categories_search_level_options: [],
      how_they_know_us: null,
      howKnowOptions: [
        { id: "google", label: "Google" },
        { id: "linkedin", label: "Linkedin" },
        { id: "facebook", label: "Facebook" },
        { id: "recommendation", label: "Recommandation" },
        { id: "email", label: "Email" },
      ],
      looking_for: null,
      lookingFor: [],
      langs: []
    };
  },
  components: {
    treeselect: Treeselect,
    AlertError,
    Features,
    Logo
  },
  created() {
    this.geCountries();
    this.$store.dispatch("alert/clear");
    this.verifyHash();
    this.getParametersOptions(5);
    this.getLanguages();
    this.referred = this.$route.params.referred
    var d = new Date();
    d.setTime(d.getTime()+(60*24*60*60*1000));
    var expires = "; expires="+d.toGMTString();

    if(this.referred == undefined){
      var match = document.cookie.match(new RegExp('(^| )referred=([^;]+)'));
      if (match && match[2]) {
          this.referred = match[2]
      }
    }else{
      document.cookie = "referred=" + this.referred + expires+"; path=/";
    }

    // esto lo quite dela linea 145: pattern="^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[ !#$%&'()*+,-./:;<=>?@\[\\\]^_`{|}~]){1,}).{8,16}$"
  },
  watch: {
    filterCountry(newValue){
      this.countriesFiltered = this.countries.map( e => ({...e}))
      if(newValue.length > 2){
        this.countriesFiltered = this.countriesFiltered
                                  .filter( e => e.name.toUpperCase().includes(newValue.toUpperCase()))
        this.countriesFiltered.forEach( e => e.visible = true )
      }
    },
    country_id(newValue, oldValue){
      if(newValue.id === "3333") {
        this.flagActually = null
        return
      }

      //if(newValue.id != "3333"){
        const flag = this.countries.find( el => el.id === newValue.id).iso
        this.flagActually = require('@/assets/images/flags/' + flag +  '.svg' )
        this.showFlag = true
      //}
    },
    emailConfirmed: function () {
      if(this.emailConfirmed){

        if (this.clientId == null) {

          this.showClientParameters = true;
          this.showUserParameters = false;
          this.showVerificationCode = false;
        } else {
          this.showClientParameters = false;
          this.showUserParameters = false;
          this.showVerificationCode = false;
        }
        this.$router.push("/onboarding/1/0");
      }else{
        this.showClientParameters = false;
        this.showUserParameters = false;
        this.showVerificationCode = true;
      }
    },
    'firstname'(){
      this.firstname = this.$sanitize(this.firstname);
    },
    'lastname'(){
      this.lastname = this.$sanitize(this.lastname);
    },
    'company'(){
      this.company = this.$sanitize(this.company);
    },
    'phone'(){
      this.phone = this.$sanitize(this.phone);
    },
    'email'(){
      this.email = this.$sanitize(this.email);
    },
    'language_id'(){
      this.language_id = this.$sanitize(this.language_id);
    },
    'username'(){
      this.username = this.$sanitize(this.username);
    },
    'password'(newValue, oldValue){
      if(newValue.length > 0){

        if(newValue.length > 5 && newValue.length < 17){
          this.validatePassword.long = true
        } else {
          this.validatePassword.long = false
        }

        if(/[0-9]/.test(newValue)){
          this.validatePassword.number = true
        } else {
          this.validatePassword.number = false
        }

        if( /[a-z]/.test(newValue)){
          this.validatePassword.lowercase = true
        } else {
          this.validatePassword.lowercase = false
        }

        if( /[A-Z]/.test(newValue)){
          this.validatePassword.uppercase = true
        } else {
          this.validatePassword.uppercase = false
        }
      } else {
        this.validatePassword = {
          long: false,
          number: false,
          uppercase: false,
          lowercase: false,
        }
      }
    }
  },
  methods: {
    changeCountry(countryId){
      this.country_id = this.countries.find( e => e.id === countryId)
    },
    countryDefault(){
      const flag = this.countries.find( el => el.id == 73).iso
      this.flagActually = require('@/assets/images/flags/' + flag +  '.svg' )
    },
    verifyHash() {
      if (this.$route.query.hash !== undefined) {
        this.hash = this.$route.query.hash;

        if (this.hash != null) {
          clientsService.verifyHash(this.$route.query.hash).then((result) => {
            if (result.client_id != null) {
              this.clientId = result.client_id;
            } else {
              this.clientId = "INVALID";
            }
          });
        } else {
          this.$router.push("/login");
        }
      }
    },
    getParametersOptions(type_id) {
      campaignsService.getParameterTypesOptions(type_id).then((response) => {
        response.forEach((item) => {
          item.label = item.name;
        });
        this.companySizeOptions = response;
      });
      categoriesService.getCategoriesGoogleParent().then((response) => {
        this.hierarchyoptionsGoogle = response;
      });
      categoriesService.getCategoriesSearchFunction().then((response) => {
        this.categories_search_function_options = response;
      });
      categoriesService.getCategoriesSearchLevel().then((response) => {
        this.categories_search_level_options = response;
      });
      let lookingForOption = ["curious", "verified-business-contacts", "send-emails", "verified-business-contacts-and-send-emails" ];
      lookingForOption.forEach((item,key) => {
        this.lookingFor.push({"id": item, "label": this.$t("lang.lookingfor."+item) })
      });
    },
    handleSubmit(e) {
      if(!this.validAgree()) return false

      this.submittedData
        ? (this.submittedDataSecond = true)
        : (this.submittedData = true);

      const { dispatch } = this.$store;

      let dataUser = {};
      dataUser.name = this.firstname;
      dataUser.lastname = this.lastname;
      dataUser.company = this.company;
      dataUser.phone = `+${this.country_id.phone_code}-${this.phone}`;
      dataUser.email = this.username;
      dataUser.referred = this.referred;
      dataUser.password = this.password;
      dataUser.username = this.username;
      dataUser.client_id = this.clientId;
      dataUser.language_id = this.language_id;

      if (this.checkForm()) {
        dispatch("authentication/create", { dataUser });
        this.$store.dispatch("alert/clear");
      }
    },
    validAgree(){
      if(this.checkAgree === null) this.checkAgree = false
      if(this.checkPolicy === null) this.checkPolicy = false
      if(this.checkAgree === false || this.checkPolicy === false) return false
      return true
    },
    handleSubmitParameters(e) {
      if (this.showClientParameters == true) {
        if (
          this.salaries != null ||
          this.categories_allowed != null ||
          this.categories_search_function != null ||
          this.categories_search_level != null ||
          this.how_they_know_us != null ||
          this.looking_for != null
        ) {
          clientsService
            .setParameters({
              salaries: this.salaries,
              categories_allowed: this.categories_allowed,
              how_they_know_us: this.how_they_know_us,
              looking_for: this.looking_for
        })
            .then((result) => {
              usersService
                .setParameters(
                  this.categories_search_function,
                  this.categories_search_level
                )
                .then((result) => {
                  this.$router.push("/");
                });
            });
        } else {
          this.$router.push("/");
        }
      } else {
        if (
          this.categories_search_level != null
        ) {
          usersService
            .setParameters(
              this.categories_search_function,
              this.categories_search_level
            )
            .then((result) => {
              this.$router.push("/dashboard");
            });
        }
      }
    },
    onSelect(node, instanceId) {
      this.salaries = node.label;
    },
    onDeselect(node, instanceId) {
      this.salaries = null;
    },
    emailSent() {
      if (this.user !== null && this.user.verificationcode != null) {
        return true;
      }
      return this.$store.state.authentication.status.emailSent;
    },
    checkVerificationCode() {
      this.submittedCode
        ? (this.submittedCodeSecond = true)
        : (this.submittedCode = true);
      const { code, username, password, clientId } = this;
      const { dispatch } = this.$store;
      if (this.code) {
        dispatch("authentication/verificationcode", {
          code,
          username,
          password,
          clientId,
        });
      }

    },
    resendVerificationCode() {
      const { username } = this;
      const { dispatch } = this.$store;
      dispatch("authentication/resendVerificationCode", {
        username
      }).then( result => {
        this.codeSent = true
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          html: this.$t("lang.accountcreation.verificationcoderesend", { "user_email" : this.userEmail }),
          showConfirmButton: true,
          timer: 10000,
        });
      });
    },
    checkForm: function (e) {
      this.errors = [];
      if (
        this.firstname &&
        this.lastname &&
        this.firstname &&
        this.company &&
        this.phone &&
        this.confirmpass &&
        this.username
      ) {
        if (this.password != this.confirmpass) {
          this.errors.push("The password is not the same");
          return false;
        }
        return true;
      }
      this.errors.push("You must complete all the fields");
      return false;
    },
    goToStep(step) {
      //tiene que ir gotostep(1)
      this.$emit("goToStep", step);
    },
    getLanguages() {
      lenguagesService.getAll().then((result) => {
        this.langs = result;
      });
    },
    geCountries() {
      countriesService.getAll().then((result) => {
        this.countries = result.map(el => {
          return {
            ...el,
            iso: el.iso.toLowerCase(),
            visible: this.optionsDefault.includes(el.iso) ? true :false
          }
        });
        this.countriesFiltered = this.countries
        this.countryDefault();
      });
    },
  },
};
</script>
<style scoped>

/* .mt2em {
  margin-top: 4%;
} */
@media only screen and (max-width: 600px) {
  .mobile-100 {height:100vh}
}
@media (min-width: 992px) {
  .hv-md-100 {
    height: 100vh;
  }
}
@media (max-width: 991px) {
  .mymd-5 {
    margin-top: 2em;
    margin-bottom: 2em;
  }
}
@media (max-width: 767px) {
  .mbsm-2 {
    margin-bottom: 1.5em;
  }
}
.reqfield:after {
  content: "*";
  font-weight: 400;
  color: red;
  padding-left: 0.2em;
  font-size: 1em;
}

svg.vue-treeselect__option-arrow {
  display: none !important;
}

div.vue-treeselect__option-arrow-container {
  font-family: "icomoon" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

div.vue-treeselect__option-arrow-container::before {
  content: "\f196";
  color: #5155ea;
}

.detail {
  background-color: #1f2041;
}

.logooliver {
  width: 140px;
}
.calendar {
  width: 300px;
}
.flag {
  width: 25px;
}
.flag2 {
  width: 12px;
}
.border border-dark {
  border:2px solid red
}

.icon-feature {
  width: 32px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
